<template>
  <!-- 销售记录 -->
  <div class="viewContainer">
    <!-- 销售记录列表 -->
    <div class="main_container">
      <section class="model_section" style="display: flex;justify-content: space-between;">
        <div>
          <p class="model_top_title">套餐包管理</p>
        </div>
        <div style="margin-right: 10px;">
          <el-button type="danger" @click="showAdd('', 1)" data-btnmark="add">新增</el-button>
        </div>
      </section>
      <div class="table_container">
        <el-table :data="xsjlList" stripe border>
          <el-table-column label="序号" align="center" width="60">
            <template scope="scope"> <span>{{ scope.$index + 1 }}</span> </template>
          </el-table-column>
          <el-table-column label="套餐包名称" align="center">
            <template scope="scope">
              <span :title="scope.row.pkgname"> {{ scope.row.pkgname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="价格" align="center">
            <template scope="scope">
              <span :title="scope.row.price"> {{ scope.row.price }} 元</span>
            </template>
          </el-table-column>
          <el-table-column label="过期日期" align="center">
            <template scope="scope">
              <span :title="scope.row.validdate"> {{ scope.row.validdate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" align="center">
            <template scope="scope">
              <span :title="scope.row.createtime"> {{ scope.row.createtime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注" align="center">
            <template scope="scope">
              <span :title="scope.row.remark"> {{ scope.row.remark }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="创建人" align="center">
                        <template scope="scope">
                            <span :title="scope.row.profit_sharing_rate"> {{ scope.row.profit_sharing_rate }}</span>
                        </template>
                    </el-table-column> -->
          <el-table-column label="操作" fixed="right" align="center" width="260">
            <template scope="scope">
              <span class="handle" @click="showAdd(scope.row, 2)"> <i class="el-icon-view" /> 查看 </span>
              <span class="handle" @click="handleUpper(scope.row, 1)" v-show="scope.row.status == 2"> <i
                  class="el-icon-upload2" /> 上架 </span>
              <span class="handle" @click="handleUpper(scope.row, 2)" v-show="scope.row.status == 1"> <i
                  class="el-icon-download"></i> 下架 </span>
              <span class="handle" @click="showAdd(scope.row, 3)"><i class="el-icon-edit-outline"></i>
                编辑</span>
              <span class="handle" @click="handleUpper(scope.row, 3)"> <i class="el-icon-delete" /> 删除
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="currentChangeOne" :page-size="10" :total="totalOne"
          :current-page="pageIndexOne" style="float:right;margin: 10px 0;" />
      </div>
    </div>

    <!-- 新增编辑套餐包 -->
    <el-dialog :title="seeshow" :visible.sync="showGive" :center="true" width="40%">
      <el-form>
        <el-form-item label="套餐包名称 :" style="width:80%" label-width="100px">
          <el-input v-model="pkgname" placeholder="请输入套餐包名称" maxlength="10" />
        </el-form-item>
        <el-form-item label="套餐包价格 :" style="width:80%" label-width="100px">
          <el-input v-model="price" placeholder="请输入套餐包价格" maxlength="6" />
        </el-form-item>
        <el-form-item label="套餐包类型：" style="width:80%" label-width="100px">
          <el-select v-model="pkgtype" filterable placeholder="请选择">
            <el-option v-for="(item, index) in genderArr" :key="index" :label="item.Name" :value="item.Id" />
          </el-select>
        </el-form-item>
        <el-form-item label="过期日期 :" style="width:80%;" label-width="100px">
          <el-date-picker style="width:50%;" type="date" v-model="validdate" :editable="false" value-format="yyyy-MM-dd"
            :disabled-date="disableBeforeToday" :picker-options="pickerOptions" />
          <el-checkbox v-model="yxqxOne" style="margin-left: 10px;">永不</el-checkbox>
        </el-form-item>
        <el-form-item label="邀请人分佣比 :" style="width:80%;" label-width="100px">
          <el-input style="width: 50%;" v-model="profit_sharing_rate" placeholder="请输入邀请人分佣比" maxlength="2"
            onkeyup="value=(value.replace(/\D/g,'')==''?'':parseInt(value))" />&nbsp;&nbsp;%&nbsp;&nbsp;
        </el-form-item>
        <el-form-item label="套餐包明细：" style="width:80%;" label-width="100px">
          <div class="package-detail-layout">
            <el-select style="width:30%" multiple v-model="selectedProductIds" filterable placeholder="请选择"
              @change="handleSelectChange">
              <el-option v-for="(item, index) in producttype" :key="index" :label="item.productname"
                :value="item.productid" />
            </el-select>
            <!-- <el-input style="width:40%" v-model="productnum" placeholder="请输入数量" maxlength="2"
            onkeyup="value=(value.replace(/\D/g,'')==''?'':parseInt(value))" /> -->
            <div class="package-input-group">
              <div v-for="(item, idx) in productItems" :key="idx" class="input-row">
                <span style="margin-right: 8px;">{{ item.product.productname }}</span>
                <el-input style="width: 120px;" :disabled="item.product.producttype == 2?true:false" v-model="item.num"
                  :placeholder="item.product.producttype === 1 ? '请输入数量' : '数量'"
                  @input="(val) => handleQuantityInput(item, val)" maxlength="4" />
                <span style="margin-left: 8px;">{{ item.product.unit }}</span>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="备注 :" style="width:80%;" label-width="100px">
          <el-input type="textarea" v-model="remark" placeholder="请输入备注：" :autosize="{ minRows: 2, maxRows: 8 }"
            maxlength="150" show-word-limit />
        </el-form-item>
      </el-form>
      <!-- 弹框按钮 -->
      <div style="text-align:center">
        <el-button @click="showGive = false">取消</el-button>
        <el-button type="danger" @click="editSubmit()">确定</el-button>
      </div>
    </el-dialog>

    <!-- 抽屉详情 size="50%" -->
    <el-drawer :visible.sync="isSeePopup" :show-close=false>
      <template v-slot:title>
        <ul class="drawer_title">
          <li>订单详情</li>
        </ul>
      </template>
      <div class="drawer_div">
        <ul class="drawer_ul">
          <li>
            <span class="watch_first">套餐包名称：</span>
            <span>{{ formDetails.pkgname }}</span>
          </li>
          <li>
            <span class="watch_first">套餐包类型：</span>
            <span>{{ formDetails.pkgtype == 1 ? '交付宝套餐' : '' }}</span>
          </li>
          <li>
            <span class="watch_first">价格：</span>
            <span>{{ formDetails.price }}元</span>
          </li>
          <li>
            <span class="watch_first">过期日期：</span>
            <span>{{ formDetails.validdate ? formDetails.validdate : '永不过期' }}</span>
          </li>
          <li>
            <span class="watch_first">邀请人返佣比：</span>
            <span>{{ formDetails.profit_sharing_rate }}%</span>
          </li>
          <li>
            <span class="watch_first">套餐明细：</span>
            <span style="display: inline-table;">
              <ul v-for="item in formDetails.details" :key="item.productid">
                <li>{{ item.producttype == 1 ? '【产品】' :'【权益】' }}{{ item.productname }} {{ item.producttype == 2 ? '' :
                  item.num }} {{ item.unit }}</li>
              </ul>
            </span>
          </li>
          <li>
            <span class="watch_first">备注：</span>
            <span>{{ formDetails.remark }}</span>
          </li>
          <!-- <li>
                        <span class="watch_first">套餐包明细：</span>
                        <span style="display: inline-table;margin-left:-40px;">
                            <ul v-for="item in formDetails.CouponsInfoList" :key="item">
                                <li>{{ item }}</li>
                            </ul>
                        </span>
                    </li> -->
        </ul>
        <div class="drawer_foot">
          <el-button type="danger" @click="cancelForm">关 闭</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { packagegetlist, packagegetinfo, packagechangestatus, packagedel, getproductlist, packagesave } from "../../api/shopWindow";
export default {
  name: "salesRecords",
  mixins: [alertTrends],
  data() {
    return {
      seeshow: '', //显示名称
      pkgname: '', //套餐包名称
      pkgtype: 1, //套餐包类型
      price: '', //套餐包价格
      validdate: '', //过期日期
      profit_sharing_rate: '', //购买套餐时给邀请人的分佣比例
      remark: '', //备注

      genderArr: [{
        Id: 1,
        Name: '交付宝套餐'
      }],  //类型
      producttype: [],//套餐包明细
      selectedProductIds: [], // 现在存储选中的 productid（如 [1,3]）
      productItems: [], // 每个元素：{ product: 产品对象, num: 数量 }
      operatetype: '',  //判断新增还是编辑 1=新增 2=编辑
      pkgid: '', //套餐包ID（编辑时必传）

      yxqxOne: false, // 长期有效/永不 默认勾选
      isSeePopup: false, //查看
      essentialInformation: [],
      formDetails: [],//详情

      xsjlList: [],
      pageIndexOne: 1,
      totalOne: 0,

      zsjlList: [],
      pageIndexTwo: 1,
      totalTwo: 0,

      showGive: false,
      giveNum: '',
      csid: 0,
      giveFrequency: [],

      pickerOptions: {
        disabledDate: (date) => this.disableBeforeToday(date)
      }
    }
  },
  methods: {
    // 套餐包列表
    initOne() {
      let obj = {
        pkgtype: 0,
        page: this.pageIndexOne, // 页码
        size: 10, // 条数
      }
      packagegetlist(obj).then(data => {
        if (data.resultCode == 1) {
          this.xsjlList = data.resultObj.list;
          this.totalOne = data.resultObj.totalcount;
        } else {
          this.xsjlList = [];
          this.totalOne = 0
        }
      })
    },
    // 分页
    currentChangeOne(val) {
      this.pageIndexOne = val;
      this.initOne()
    },

    showAdd(row, type) {
      let that = this;
      // this.getprovince();
      if (type == 1) {
        this.seeshow = '新增';
        this.showGive = true;
        this.operatetype = 1;
        this.pkgid = '';
        this.pkgname = '';
        this.pkgtype = 1;
        this.price = '';
        this.validdate = '';
        this.yxqxOne = false;
        this.remark = '';
        this.profit_sharing_rate = '';
        this.producttype = [],//套餐包明细
        this.selectedProductIds = [], // 现在存储选中的 productid（如 [1,3]）
        this.productItems = [], // 每个元素：{ product: 产品对象, num: 数量 }
        this.getproductlistFun(); // 获取所有上架的产品和权益
      }
      if (type == 2) {
        // this.seeshow = '查看';
        this.isSeePopup = true;
        this.packagegetinfoFun(row);//获取套餐包详情

      }
      if (type == 3) {
        this.seeshow = '编辑';
        this.showGive = true;

        this.getproductlistFun(); // 获取所有上架的产品和权益
        this.packagegetinfoFun(row, 3);//获取套餐包详情
      }
    },
    // 上架1 & 下架2 & 删除3
    handleUpper(row, type) {
      if (type == 1) { // 上架
        this.conditionFun(row.pkgid, 1)
      } else if (type == 2) { //下架2
        this.$swal({
          type: "warning",
          text: "重要信息，你确定要下架吗？",
          showCancelButton: true,
          reverseButtons: true, // 添加这一行来反转按钮顺序
          cancelButtonText: "取消",
          confirmButtonText: "确定",
        }).then((res) => {
          if (res.value) {
            this.conditionFun(row.pkgid, 2)
          }
        });
        
      } else { //删除3
        this.$swal({
          type: "warning",
          text: "重要信息，你确定要删除吗？",
          showCancelButton: true,
          reverseButtons: true, // 添加这一行来反转按钮顺序
          cancelButtonText: "取消",
          confirmButtonText: "确定",
        }).then((res) => {
          if (res.value) {
            let params = {
              pkgid: row.pkgid, // 套餐包ID
            };
            packagedel(params).then(data => {
              if (data.resultObj > 0) {
                this.$swal({
                  type: "success",
                  text: "删除成功",
                });
                this.initOne();
              }
            })
          }
        });

      }
    },
    // 上架/下架
    conditionFun(pkgid, y) {
      let params = {
        pkgid: pkgid, // 套餐包ID
        status: y,
      };
      packagechangestatus(params).then(data => {
        if (data.resultCode == 1) {
          this.$swal({
            type: "success",
            text: `${y == 1 ? '已上架成功' : '已下架成功'}`,
          });
          this.initOne();
        }
      })
    },
    //获取套餐包详情
    packagegetinfoFun(row, edit) {
      packagegetinfo({}, row.pkgid).then(data => {
        if (data.resultCode == 1) {
          let formDetails = data.resultObj;
          if (edit){  //编辑
            this.operatetype = 2;
            this.pkgid = formDetails.pkgid;
            this.pkgname = formDetails.pkgname;
            this.pkgtype = 1;
            this.price = formDetails.price;
            this.validdate = formDetails.validdate;
            this.yxqxOne = formDetails.validdate?false:true;
            this.icon = '';
            this.remark = formDetails.remark;
            this.profit_sharing_rate = formDetails.profit_sharing_rate;
            let firstDetails = formDetails.details;
            this.producttype = firstDetails;
            this.selectedProductIds = firstDetails.map(item => item.productid);
            let convertedDetails = firstDetails.map(item => {
              // 1. 解构出 num，剩余字段存入 productData
              const { num, ...productData } = item;
              return {
                num,
                product: productData
              };
            });
            this.productItems = convertedDetails;
          } else {
            this.formDetails = formDetails;
          }
        } else {
          this.formDetails = [];
        }
      })
    },
    cancelForm() {
      this.isSeePopup = false
    },
    getproductlistFun() {
      getproductlist({}).then(data => {
        if (data.resultCode == 1) {
          this.producttype = data.resultObj;
        }
      })
    },
    // 套餐包明细
    handleSelectChange() {
      const newProductItems = [];
      this.selectedProductIds.forEach(productId => {
        // 从 producttype 中找到对应的产品对象
        const product = this.producttype.find(item => item.productid === productId);
        if (!product) return;

        // 保留已有输入值
        const existingItem = this.productItems.find(
          item => item.product.productid === productId
        );
        if (existingItem) {
          newProductItems.push(existingItem);
        } else {
          // 根据 producttype 设置初始数量
          let num = "1"; // producttype=2 默认 1
          if (product.producttype === 1) {
            num = ""; // producttype=1 初始为空
          }
          newProductItems.push({ product, num });
        }
      });
      this.productItems = newProductItems;
    },

    /**
     * 处理输入框内容：过滤非数字，根据产品类型设置规则
     * @param {Object} item - productItems 中的项（包含 product 和 quantity）
     * @param {string} val - 输入框原始值
     */
    handleQuantityInput(item, val) {
      const value = val.replace(/\D/g, "");
      if (item.product.producttype === 1) {
        item.num = value; // 允许空值
      } else if (item.product.producttype === 2) {
        item.num = value || "1"; // 空值自动设为 1
      }
    },
    // 确定按钮
    editSubmit() {
      if (this.pkgname == "") {
        this.showAlert('请输入套餐包名称');
        return false;
      }
      if (this.price == "") {
        this.showAlert('请输入套餐包价格');
        return false;
      }
      if (this.pkgtype == '') {
        this.showAlert('请选择套餐包类型');
        return false;
      }
      const selectedDate = new Date(this.validdate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);
      if (today >= selectedDate) {
        // 选择的日期在今天之后，显示提示
        this.showAlert('过期日期不能小于当天');
        return false;
      }
      if (this.profit_sharing_rate == '') {
        this.showAlert('请输入邀请人分佣比');
        return false;
      }
      if (this.pkgtype == '') {
        this.showAlert('请选择套餐包明细');
        return false;
      }
      if (this.remark == '') {
        this.showAlert('请输入备注');
        return false;
      }
      let details = this.productItems.map(item => ({
        productid: Number(item.product.productid), // 提取 productid
        num: Number(item.num) // 将字符串 num 转为数字（也可用 parseInt(item.num, 10)）
      }));
      var params = {
        operatetype: this.operatetype,//1=新增 2=编辑
        pkgid: this.operatetype == 1 ? 0 : this.pkgid,//1=新增 2=编辑
        pkgname: this.pkgname, //套餐包名称
        pkgtype: this.pkgtype,//套餐包类型 1=交付宝套餐
        price: Number(this.price),//套餐包售卖价格
        validdate: this.validdate,//过期日期 永不过期则此字段传空
        icon: '',//套餐包图标 未上传则传空
        remark: this.remark,//套餐包备注
        profit_sharing_rate: Number(this.profit_sharing_rate)/100,//购买套餐时给邀请人的分佣比例
        details: details,
      };
      // 判断是编辑还是新增
      packagesave(params).then(data => {
        if (data.resultCode == 1) {
          // data = data.resultObj;
          this.showAlert('操作成功', 'success');
          this.showGive = false;
          this.initOne();
        } else {
          this.showAlert(data.resultMsg);
          return false;
        }
      }).catch(err => {
        this.showAlert(err, 'error');
        return false;
      });
    },

    // 限制日期
    disableBeforeToday(date){
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const isDisabled = date.getTime() <= today.getTime();
      return isDisabled;
    },




  },
  mounted() {
    this.initOne(); // 初始化查询列表
  },
  watch: {
    // 监听永不
    'yxqxOne'() {
      if (this.yxqxOne) {
        this.validdate = "";
      }
    },
    // 监听过期日期
    'validdate'() {
      if (this.validdate) {
        this.yxqxOne = false;
      }
    },
  }
}
</script>
<style scoped>
.drawer_title {
  padding-left: 0;
  display: flex;
  justify-content: space-between;
}

.drawer_title>li:first-child {
  font-size: 18px;
  font-weight: bolder;
  color: #333;
}

.drawer_div {
  width: 96%;
  margin: 0 auto;
}

.drawer_ul:first-child {
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 5px;
}

.drawer_ul>li {
  line-height: 40px;
  font-size: 16px;
}

.drawer_ul>li>span {
  font-size: 15px;
}

.drawer_ul>li>span>img {
  width: 66px;
  height: 66px;
  margin-left: 10px;
  margin-bottom: 10px;
}


/* 外层布局：并排显示多选框和输入区 */
.package-detail-layout {
  display: flex;
  align-items: flex-start;
  /* 垂直顶部对齐，避免多选框和输入区高度差异导致错位 */
  gap: 24px;
  /* 多选框与输入区的间距 */
}

/* 输入区：垂直排列每个输入项 */
.package-input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  /* 输入项之间的间距 */
}

/* 单个输入项：名称与输入框横向对齐 */
.input-row {
  display: flex;
  align-items: center;
  gap: 12px;
  /* 名称与输入框的间距 */
}

/* 产品名称：固定宽度 + 右对齐，确保输入框整齐 */
.product-name {
  min-width: 80px;
  text-align: right;
}

</style>


// WEBPACK FOOTER //
// productpackage.vue?ca5d037e